import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { DataProviderService } from './data-provider.service';
import { first } from 'rxjs/operator/first';
import { IDataSource } from './IDataSource';
import { IArticle } from './IArticle';
import { LangDataService } from './lang-data.service';

@Injectable()
export class ArticleDataService {
    constructor(
        private dataProvider: DataProviderService,
        private lang: LangDataService
    ) {}

    public getArticle(key: string, withDetails: boolean = true): Observable<IArticle> {
        const dataSource: Observable<IDataSource> = this.dataProvider.getData(withDetails);

        return dataSource.map(ds => {
            const article = ds.articles[key];
            if (article === undefined)
                throw new Error(`Article "${key}" does not exist.`);

            return article;
        });
    }

    public getArticles(withDetails: boolean = true): Observable<IArticle> {
        const dataSource: Observable<IDataSource> = this.dataProvider.getData(withDetails);

        return dataSource
            .map(ds => Observable.from(Object.values(ds.articles)))
            .concatAll();
    }

    public getArticlesOfModel(withDetails: boolean, modelKey: string): Observable<IArticle> {
        return this.getArticles(withDetails)
            .filter(a => a["model-key"] === modelKey);
    }

    /**
     * Returns an observable emitting all known special articles for a model, excluding the "vergoldet" one.
     */
    public getSpecialArticlesOfModel(modelKey: string): Observable<IArticle> {
        return this.getArticlesOfModel(true, modelKey)
            .filter(a => a.attributes["special-type"] !== undefined && a.attributes["special-type"] != null)
            // "vergoldet" is actually another special color, but since there's no special color selection required for this kind of article
            // we don't need any special treatment for it.
            .filter(a => a.attributes["special-type"][0] !== 2);
    }

    /**
     * Note that even gold is a special color article, it is not considered as such by the bpk.
     */
    public isSpecialColorArticle(article: IArticle) {
        const isSpecialColorArticle = article.attributes["special-type"] !== null && article.attributes["special-type"] !== undefined;
        const isGoldArticle = isSpecialColorArticle && article.attributes["special-type"][0] === 2;

        return isSpecialColorArticle && !isGoldArticle;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/article-data.service.ts